document.addEventListener('DOMContentLoaded', function () {
  var yearNode = document.querySelector('.pot-home [data-pot-current-year]');
  if (yearNode) {
    yearNode.textContent = String(new Date().getFullYear());
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href*="#"]');
    if (!link) return;

    var href = link.getAttribute('href');
    if (!href) return;

    var url;
    try {
      url = new URL(href, window.location.href);
    } catch (e) {
      return;
    }

    if (!url.hash || url.hash === '#') return;
    if (url.origin !== window.location.origin) return;
    if (url.pathname !== window.location.pathname) return;

    var hash = url.hash;
    var target = document.querySelector(hash);
    if (!target) return;

    event.preventDefault();

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({
      behavior: reduceMotion ? 'auto' : 'smooth',
      block: 'start',
    });

    if (window.history && window.history.pushState) {
      window.history.pushState(null, '', hash);
    } else {
      window.location.hash = hash;
    }
  });
});
